// import React from "react";
// import ReactImageMagnify from "react-image-magnify";
// import classes from "./ProductImageZoom.module.css";

// export default function ProductImageZoom({ src, alt }) {
//   return (
//     <div className={classes.zoomWrapper}>
//       <ReactImageMagnify
//         {...{
//           smallImage: {
//             alt: alt,
//             isFluidWidth: true,
//             src: src,
//           },
//           largeImage: {
//             src: src,
//             width: 1200,
//             height: 1200,
//           },
//           enlargedImageContainerStyle: {
//             zIndex: 9999,
//             background: "#fff",
//             border: "1px solid #ddd",
//           },
//           isHintEnabled: true,
//           shouldUsePositiveSpaceLens: true, // classic hover zoom
//           lensStyle: {
//             backgroundColor: "rgba(0,0,0,0.2)", // optional lens styling
//           },
//         }}
//       />
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import ReactImageMagnify from "react-image-magnify";
import classes from "./ProductImageZoom.module.css";
import { PLACEHOLDER_IMAGE } from "../../utils/image";

export default function ProductImageZoom({ src, alt }) {
  const [imgSrc, setImgSrc] = useState(src || PLACEHOLDER_IMAGE);

  // Update imgSrc whenever src prop changes
  useEffect(() => {
    setImgSrc(src || PLACEHOLDER_IMAGE);
  }, [src]);

  return (
    <div className={classes.zoomWrapper}>
      <ReactImageMagnify
        {...{
          smallImage: {
            alt: alt,
            isFluidWidth: true,
            src: imgSrc,
            onError: () => setImgSrc(PLACEHOLDER_IMAGE),
          },
          largeImage: {
            src: imgSrc,
            width: 1200,
            height: 1200,
          },
          enlargedImageContainerStyle: {
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #ddd",
          },
          isHintEnabled: true,
          shouldUsePositiveSpaceLens: true,
          lensStyle: {
            backgroundColor: "rgba(0,0,0,0.2)",
          },
        }}
      />
    </div>
  );
}
